<style scoped>
    * {
        font-family: PingFangSC-Regular, PingFang SC;
    }

    .main {
        padding: 0.2rem;
    }

    .li {
        display: flex;
        justify-content: space-between;
        height: 0.5rem;
        line-height: 0.5rem;
    }

    .title {
        font-size: 0.14rem;
        font-weight: 400;
        color: #333333;
    }

    .img {
        width: 0.1rem;
        height: 0.1rem;
    }

    .line {
        width: 100%;
        height: 1px;
        background: #F5F5F5;
    }


</style>
<template>
    <div class="main">
        <div>
            <div class="li" @click="redirect(1)">
                <div class="title">用户注册协议</div>
                <div class="img"><img src="@/assets/img/vip/right_tip.png" style="width: 100%;height: 100%;"
                                      alt=""/></div>
            </div>
            <div class="line"></div>
        </div>

        <div>
            <div class="li" @click="redirect(2)">
                <div class="title">隐私保护政策</div>
                <div class="img"><img src="@/assets/img/vip/right_tip.png" style="width: 100%;height: 100%;"
                                      alt=""/></div>
            </div>
            <div class="line"></div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            };
        },
        created() {
            this.util.title("协议列表");
        },
        methods: {
            redirect(index) {
                if (index == 1) {
                    window.location.href = "https://thread.tcjhz.com/agreement/tczs_zc.html"
                } else if (index == 2) {
                    window.location.href = "https://thread.tcjhz.com/agreement/tczs_ys.html"
                }
            }

        },
    };
</script>
